import { colors } from "components/Theme/WebTheme.js";
import { container, primaryColor } from "./material-kit-react.js"

const footerStyle = {
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    margin: "0",
    float: "right!important"
  },
  footer: {
    padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative"
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: colors.WHITE
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  },
  footerPillButton: {
    cursor: "pointer",
    color: "#FFFFFF",
    backgroundColor: "#4169E2",
    padding: "12px 0",
    borderRadius: "30px",
    margin: "8px",
    display: "inline-block",
    textTransform: "uppercase",
    fontSize: "10px",
    textDecoration: "none",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 10px rgba(65, 105, 226, 0.4)",
    width: "130px",
    textAlign: "center",
    "&:hover": {
      fontSize: "11px",
    },
  }
};
export default footerStyle;
